export const CURSOR_UPDATE = 'CURSOR_UPDATE';
export const CURSOR_REMOVE = 'CURSOR_REMOVE';

export const CURSOR_TYPES = {
    POINTER: 'pointer',
    PEN: 'pen',
    ERASER: 'eraser',
};
